import { render } from "./AIFactory.vue?vue&type=template&id=b337ae0e"
import script from "./AIFactory.vue?vue&type=script&lang=js"
export * from "./AIFactory.vue?vue&type=script&lang=js"

import "./AIFactory.vue?vue&type=style&index=0&id=b337ae0e&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__